import {ComputationResult} from './../computation-result';
import {Computation} from './../computation';
import {_AvailableResult} from './../available-result';

/**
 * Generated from com.dataiku.dip.eda.compute.computations.bivariate.MutualInformation
 */
export interface MutualInformation extends Computation._BivariateComputation {
    // PolyJson type
    type: 'mutual_information';
}

export function isMutualInformation(toTest: Computation): toTest is MutualInformation { return 'mutual_information' === toTest.type; }

export namespace MutualInformation {
    /**
     * Generated from com.dataiku.dip.eda.compute.computations.bivariate.MutualInformation$MutualInformationResult
     */
    export interface MutualInformationResult extends _AvailableResult {
        value: number;

        // PolyJson type
        type: 'mutual_information';
    }

    export function isMutualInformationResult(toTest: ComputationResult): toTest is MutualInformationResult { return 'mutual_information' === toTest.type; }
}